import styled from 'styled-components'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body1_r16,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_body3_m12,
  Noto_DisPlay2_b32,
} from 'src/styles/fonts/NotoSansKrFonts'
import { ellip, layoutMaxSize, ZIndex } from 'src/styles/mixin'
import { Typography } from 'src/components/common/Typography'
import { Container } from 'src/components/common/Container'
import { SmallDivider, VerticalDivider } from 'src/components/common/Divider'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import RenderIf from 'src/components/common/RenderIf'
import { GiftPaymentPageProps } from 'src/pages/GiftPaymentPage/index'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import React from 'react'
import kakaoShareImage from 'src/assets/images/share/kakao_share.png'
import { Icon } from 'src/assets/svg/Icon'

const GiftPaymentPageView = ({
  resultContent,
  giftDetailData,
  giftShareData,
  mainPageNav,
  handleShareUrl,
  handleIosKakaoShare,
}: GiftPaymentPageProps) => {
  const { title, desc, infoList, afterPurchaseButton, notiText, share } = resultContent
  const { BrandName, CouponName, CouponImage } = giftDetailData!

  return (
    <S.GiftPaymentPageContainer $option={'flex_column'}>
      <S.GiftPaymentContents $option="flex_column">
        <S.GiftPaymentPrimaryContents $option="flex_column" $row_gap="10px">
          <S.GiftPaymentPrimaryWrap $option="flex_row" $column_gap="10px">
            <S.GiftPaymentStatusText $fontStyle={Noto_DisPlay2_b32} $color="var(--black-90)">
              {title}
            </S.GiftPaymentStatusText>
          </S.GiftPaymentPrimaryWrap>
          <S.GiftPaymentStatusText $fontStyle={Noto_body1_r16} $color="var(--black-50)">
            {desc}
          </S.GiftPaymentStatusText>
        </S.GiftPaymentPrimaryContents>
        <S.GiftPaymentCouponInfoContents $option="flex_column">
          <CouponCircleImage src={CouponImage} />
          <S.GiftInfoContainer $option="flex_column" $row_gap="2px">
            <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
              [{BrandName}]
            </Typography>
            <S.GiftPaymentCouponName $fontStyle={Noto_body1_b16}>
              {CouponName}
            </S.GiftPaymentCouponName>
          </S.GiftInfoContainer>
          <S.GiftPaymentInfoWrap $option="flex_column" $row_gap="10px">
            {infoList?.map(({ text, value, topDivider, valueFontStyle, bottomDivider }) => (
              <Container $option="flex_column" key={text} $row_gap="10px">
                {topDivider && <SmallDivider />}
                <S.InfoListItemWrap $option="flex_row_space_between">
                  <Typography $fontStyle={Noto_body1_m16} $color="var(--black-50)">
                    {text}
                  </Typography>
                  <Typography $style={valueFontStyle}>{value}</Typography>
                </S.InfoListItemWrap>
                {bottomDivider && <SmallDivider />}
              </Container>
            ))}
          </S.GiftPaymentInfoWrap>
          <RenderIf when={!!notiText}>
            <Container $option="flex_column" $row_gap="2px">
              {notiText?.map((text, index) => (
                <S.GiftPaymentNotiWrap key={index}>
                  <span>·</span>
                  <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
                    {text}
                  </Typography>
                </S.GiftPaymentNotiWrap>
              ))}
            </Container>
          </RenderIf>
        </S.GiftPaymentCouponInfoContents>
        <RenderIf when={!!share}>
          <S.GiftShareContainer $option="flex_row">
            <S.GiftShareBtnWrap $option="flex_row">
              <S.GiftShareButton id="kakaotalk-share-btn" onClick={handleIosKakaoShare}>
                <img src={kakaoShareImage} alt="카카오톡 공유" width={28} height={28} />
                <Typography $fontStyle={Noto_body3_m12} $color="var(--black-70)">
                  카카오톡 공유
                </Typography>
              </S.GiftShareButton>
            </S.GiftShareBtnWrap>
            <VerticalDivider height="16" color="#A6A6A6" opacity="0.5" />
            <S.GiftShareBtnWrap $option="flex_row">
              <S.GiftShareButton onClick={() => handleShareUrl(giftShareData.GiftURL)}>
                <S.UrlShareIconWrap>
                  <Icon.Share />
                </S.UrlShareIconWrap>
                <Typography $fontStyle={Noto_body3_m12} $color="var(--black-70)">
                  선물받기 url 공유
                </Typography>
              </S.GiftShareButton>
            </S.GiftShareBtnWrap>
          </S.GiftShareContainer>
        </RenderIf>
      </S.GiftPaymentContents>
      <S.GiftDetailFixedContainer $option="flex_row">
        <Container $option="flex_row" $column_gap="4px">
          <Button option={ButtonOption3('outline')} onClickFn={mainPageNav}>
            홈으로 이동
          </Button>
          <RenderIf when={!!afterPurchaseButton}>
            <Button option={ButtonOption3('active')} onClickFn={afterPurchaseButton?.onClickFn}>
              {afterPurchaseButton?.text}
            </Button>
          </RenderIf>
        </Container>
      </S.GiftDetailFixedContainer>
    </S.GiftPaymentPageContainer>
  )
}
export default GiftPaymentPageView

const S = {
  GiftPaymentPageContainer: styled(Container)`
    flex: 1;
    background-color: var(--brand-5);
    align-items: center;
    justify-content: center;
    padding: 20px 20px 90px 20px;
  `,
  GiftPaymentContents: styled(Container)`
    max-width: 360px;
  `,
  GiftPaymentPrimaryContents: styled(Container)`
    gap: 10px;
    padding: 0 20px;
    margin-bottom: 40px;
    text-align: center;
  `,
  GiftPaymentPrimaryWrap: styled(Container)`
    justify-content: center;
    align-items: center;
  `,
  GiftPaymentStatusText: styled(Typography)`
    white-space: pre-wrap;
  `,
  GiftPaymentCouponInfoContents: styled(Container)`
    border-radius: 20px;
    background-color: var(--white);
    padding: 25px 30px;
  `,
  GiftInfoContainer: styled(Container)`
    text-align: center;
    margin-top: 14px;
  `,
  GiftPaymentCouponName: styled(Typography)`
    ${ellip('line1')};
    text-align: center;
  `,
  InfoListItemWrap: styled(Container)`
    align-items: center;
  `,
  GiftPaymentInfoWrap: styled(Container)`
    margin: 20px 0;
  `,
  GiftPaymentNotiWrap: styled(Container)`
    ${Noto_body1_b16};
    display: grid;
    grid-template-columns: 14px auto;
    padding-left: 4px;
    color: var(--black-50);
  `,
  GiftShareContainer: styled(Container)`
    align-items: center;
    margin-top: 20px;
  `,
  GiftShareBtnWrap: styled(Container)`
    justify-content: center;
  `,
  GiftShareButton: styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    width: fit-content;
  `,
  UrlShareIconWrap: styled(Container)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: var(--white);
  `,
  GiftPaymentStatusImg: styled.img<{ $imgWidth: string }>`
    display: flex;
    width: ${(props) => props.$imgWidth};
  `,
  GiftPaymentRePurChaseButton: styled.button`
    display: inline-block;
    width: calc(100% - 60px);
    margin: 0 auto;
    height: 48px;
    border-radius: 12px;
    text-align: center;
    background-color: var(--brand-50);
    ${Noto_body1_b16};
    color: var(--white);
  `,
  GiftDetailFixedContainer: styled(Container)`
    justify-content: center;
    gap: 6px;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: 0;
    padding: 10px;
    background-color: var(--white);
    border: none;
    ${layoutMaxSize};
    z-index: ${ZIndex.BottomFixedContents};
  `,
}
